import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=f13f2a92&"
import script from "./AdminDetail.vue?vue&type=script&lang=js&"
export * from "./AdminDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetail.vue?vue&type=style&index=0&id=f13f2a92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports